/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ checked: NonNullable<unknown>, total: NonNullable<unknown> }} Action_Bar_Waiting_InitialInputs */



/**
* | output |
* | --- |
* | "Check in players. {checked}/{total} checked in." |
*
* @param {Action_Bar_Waiting_InitialInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_waiting_initial = /** @type {((inputs: Action_Bar_Waiting_InitialInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_Waiting_InitialInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Pointez les joueurs. ${i?.checked}/${i?.total} pointés.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Haga check-in de los jugadores. ${i?.checked}/${i?.total} con check-in.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Faça o check-in dos jogadores. ${i?.checked}/${i?.total} com check-in.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Fai il check-in dei giocatori. ${i?.checked}/${i?.total} check-in effettuati.`)
	return /** @type {LocalizedString} */ (`Check in players. ${i?.checked}/${i?.total} checked in.`)
});